export default __webpack_public_path__ + "static/media/Dark Eternal.7e541989.jpg";